export const DEBUG_OPTIONS = [
  {
    key: "replo.debug.showAgentConnectionDebug",
    label: "Show Agent Connection Debug Panel",
    description:
      "Opens the floating panel showing agent state, events, logs, and memory usage",
  },
  {
    key: "replo.debug.reduxLoggingToConsole",
    label: "Redux Logging to Console",
    description:
      "Logs all Redux actions and state changes to the browser console",
  },
  {
    key: "replo.debug.useBackendStaging",
    label: "Use Backend Staging",
    description:
      "Routes API calls to the staging backend (replo-publisher-staging.fly.dev)",
  },
  {
    key: "replo.debug.useShopifyDebugTools",
    label: "Use Shopify Debugging Tools",
    description:
      "Enables Shopify-specific debugging tools in the preview iframe",
  },
  {
    key: "replo.debug.enablePosthogSessionRecording",
    label: "Enable Posthog Session Recording",
    description: "Starts a Posthog session recording for the current session",
  },
  {
    key: "replo.debug.copyComponentJsonMinify",
    label: "Copy Component JSON as Minified",
    description:
      "Copies component JSON to clipboard as a single line instead of pretty-printed",
  },
  {
    key: "replo.debug.jsonActionPlayer",
    label: "JSON Action Player",
    description:
      "Shows the JSON Action Player button in the canvas controls toolbar",
  },
  {
    key: "replo.debug.v2debuggers",
    label: "V2 Debuggers",
    description: "Shows V2 debugger UI elements throughout the editor",
  },
  {
    key: "replo.debug.v2.logChatStreamEventsToConsole",
    label: "Log Chat Stream Events to Console",
    description:
      "Logs all V2 chat stream events to the browser console for debugging",
  },
  {
    key: "replo.debug.showNextDevServerLogs",
    label: "Show Next Dev Server Logs",
    description:
      "Shows the Next.js dev server log panel for Replo-hosted projects",
  },
  {
    key: "replo.debug.includeScaffoldFilesInSandboxSync",
    label: "Include Scaffold Files in Sandbox Sync",
    description:
      "Includes scaffold template files when syncing sandbox state (triggers iframe reload)",
  },
  {
    key: "replo.debug.showFailedPaymentState",
    label: "Show Failed Payment State",
    description:
      "Forces the failed payment UI to display for testing billing flows",
  },
];
